import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AppState } from 'src/store';

export const ofsApi = createApi({
  reducerPath: 'ofsApi',
  baseQuery: fetchBaseQuery({
    // Use environment variable or fallback to localhost
    // baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://demo-appcontrol-center-api.huewine.com/app-control/',
    //  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://rrmmarbles-api.huewine.com/app-control',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://test-appcontrol-api.huewine.com/app-control/',
    //  baseUrl: process.env.REACT_APP_API_BASE_URL || ' http://juans-ecommerce-api.juansmart.com/app-control/',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || ' http://localhost:8092/app-control/',
    //  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://159.89.175.106:8092/app-control/',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://103.211.80.132:8092/app-control/',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || ' https://juansmart.com/app-control',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || ' https://juansmart.com/app-control',
    // baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://192.168.1.124:8092/app-control/',
       baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://greeneco-api.greenecoindustry.com/app-control',
    // VITE_APPCONTROL_API_URL=https://159.89.175.106:8092
    //  VITE_APPCONTROL_API_URL=http://103.211.80.132:8092

    prepareHeaders: (headers, { getState }) => {

      const branchId = localStorage.getItem('branchID');
      const state = getState() as AppState;
      const { accessToken } = state.user?.data || {};

      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }

      headers.set('Content-Type', 'application/json');


      if (branchId) {
        headers.set('Branch-ID', branchId);
      }

      return headers;
    }
  }),
  tagTypes: ['User', 'Branch', 'Application', 'Organization', 'Category', 'Regional', 'UserRole', 'UserEntity'],
  endpoints: () => ({}),
  // Add global error handling
  keepUnusedDataFor: 300, // Keep data for 5 minutes
});
